import React from 'react';
import { Line, Bar } from 'react-chartjs-2';
import { Container, Paper, Typography } from '@mui/material';
import Chart from 'chart.js/auto';

const Analytics = ({
    totalMatches = [],
    userEngagement = [],
    popularMerchandise = []
}) => {
    const matchesData = {
        labels: totalMatches.map((match) => match.date),
        datasets: [
            {
                label: 'Total Matches Played',
                data: totalMatches.map((match) => match.count),
                backgroundColor: 'rgba(75,192,192,0.4)',
                borderColor: 'rgba(75,192,192,1)',
                fill: false,
            },
        ],
    };

    const engagementData = {
        labels: userEngagement.map((engagement) => engagement.date),
        datasets: [
            {
                label: 'User Engagement Over Time',
                data: userEngagement.map((engagement) => engagement.value),
                backgroundColor: 'rgba(153,102,255,0.2)',
                borderColor: 'rgba(153,102,255,1)',
                fill: false,
            },
        ],
    };

    const merchandiseData = {
        labels: popularMerchandise.map((item) => item.name),
        datasets: [
            {
                label: 'Popular Merchandise Items',
                data: popularMerchandise.map((item) => item.sales),
                backgroundColor: 'rgba(255,159,64,0.2)',
                borderColor: 'rgba(255,159,64,1)',
                fill: false,
            },
        ],
    };

    return (
        <Container maxWidth="lg">
            <Paper elevation={3} sx={{ padding: 3, mt: 3, background: 'transparent' }}>
                <Typography variant="h4" component="h1" gutterBottom>
                    Analytics Dashboard
                </Typography>
                <div>
                    <Typography variant="h6" component="h2">
                        Total Matches Played
                    </Typography>
                    <Line data={matchesData} />
                </div>
                <div>
                    <Typography variant="h6" component="h2">
                        User Engagement Over Time
                    </Typography>
                    <Line data={engagementData} />
                </div>
                <div>
                    <Typography variant="h6" component="h2">
                        Popular Merchandise Items
                    </Typography>
                    <Bar data={merchandiseData} />
                </div>
            </Paper>
        </Container>
    );
};

export default Analytics;
